import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var DataVisualization = /*#__PURE__*/_styled("div", true ? {
  target: "e1rrkkc30"
} : {
  target: "e1rrkkc30",
  label: "DataVisualization"
})(true ? {
  name: "43cxha",
  styles: "display:flex;flex-direction:column;gap:32px"
} : {
  name: "43cxha",
  styles: "display:flex;flex-direction:column;gap:32px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvRGF0YVZpc3VhbGl6YXRpb24vRGF0YVZpc3VhbGl6YXRpb24udmlld3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTJDIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvRGF0YVZpc3VhbGl6YXRpb24vRGF0YVZpc3VhbGl6YXRpb24udmlld3MudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuZXhwb3J0IGNvbnN0IERhdGFWaXN1YWxpemF0aW9uID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgZ2FwOiAzMnB4O1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});